import { Navigate, Outlet } from 'react-router-dom';
import { EmailVerificationGate } from '@/components/auth/EmailVerificationGate';
import { FullScreenLoader } from '@/components/common/FullScreenLoader';
import { LegalAcceptanceGate } from '@/components/legal/LegalAcceptanceGate';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { useAuth } from '@/hooks/useAuth';
import { resolveHomeRoute } from '@/lib/resolveHomeRoute';

export function RequirePractitionerAccess() {
  const { status, platformPermissions, activeScopeCode } = useAuth();

  if (status === 'loading') {
    return <FullScreenLoader />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to={APPLICATION_ROUTES.login} replace />;
  }
  if (activeScopeCode !== 'tenant') {
    return <Navigate to={resolveHomeRoute(activeScopeCode, platformPermissions)} replace />;
  }
  return (
    <EmailVerificationGate>
      <LegalAcceptanceGate>
        <Outlet />
      </LegalAcceptanceGate>
    </EmailVerificationGate>
  );
}
